import ReactPlayer from 'react-player'
import './index.css'

const IntroPlayer = () => (
  <div id="video-container-1">
    <div className="responsive-container-1">
      <ReactPlayer
        controls
        url="https://youtu.be/7H2_Ya4r6OI"
        width="100%"
        height="100%"
      />
    </div>
  </div>
)

export default IntroPlayer
